import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { eduLoginButtonLegacyDefaultV0Schema } from './default';
import { eduLoginButtonLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field — forked from the button
 * widget. Persisted entities without a `type` field land on the default branch;
 * entities tagged `type: 'zero'` land on the zero branch.
 */
const eduLoginButtonLegacyEntityUnion = z.discriminatedUnion('type', [
    eduLoginButtonLegacyDefaultV0Schema,
    eduLoginButtonLegacyZeroV0Schema,
]);

export type LegacyEduLoginButtonDefault = z.infer<typeof eduLoginButtonLegacyDefaultV0Schema>;
export type LegacyEduLoginButtonZero = z.infer<typeof eduLoginButtonLegacyZeroV0Schema>;
export type LegacyEduLoginButton = LegacyEduLoginButtonDefault | LegacyEduLoginButtonZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today.
 */
export const LegacyEduLoginButtonEntitySchema = createLegacyEntitySchema([
    { name: 'web', schema: eduLoginButtonLegacyEntityUnion },
]);
